export default {
    maps:
    [
        [   //一块
            [0,0,0,0,0, 0,0,0,0,0, 0,0,1,0,0, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //长两块
            [0,0,0,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,0,0,0,0, 0,0,0,0,0, 0,0,1,1,0, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //长三块
            [0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,0,0,0,0, 0,0,0,0,0, 0,1,1,1,0, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //长四块
            [0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,0,0,0],
            [0,0,0,0,0, 0,0,0,0,0, 1,1,1,1,0, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //长五块
            [0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0],
            [0,0,0,0,0, 0,0,0,0,0, 1,1,1,1,1, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //长L形
            [0,1,0,0,0, 0,1,0,0,0, 0,1,1,1,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,1,1,1,0, 0,1,0,0,0, 0,1,0,0,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,1,1,1,0, 0,0,0,1,0, 0,0,0,1,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,0,0,1,0, 0,0,0,1,0, 0,1,1,1,0, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //短L形
            [0,0,0,0,0, 0,1,0,0,0, 0,1,1,0,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,0,0,0,0, 0,1,1,0,0, 0,1,0,0,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,0,0,0,0, 0,0,1,1,0, 0,0,0,1,0, 0,0,0,0,0, 0,0,0,0,0],
            [0,0,0,0,0, 0,0,0,1,0, 0,0,1,1,0, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //方四块
            [0,0,0,0,0, 0,1,1,0,0, 0,1,1,0,0, 0,0,0,0,0, 0,0,0,0,0]
        ],
        [   //方九块
            [0,1,1,1,0, 0,1,1,1,0, 0,1,1,1,0, 0,0,0,0,0, 0,0,0,0,0]
        ]
    ],
    index:0,    //方块索引号
    status:0,   //方块状态号
    getDragCellColor(index){
        switch (index){
            case 0: return "#7e8ed5";
            case 1: return "#ffc63e";
            case 2: return "#ed954a";
            case 3: return "#e76a82";
            case 4: return "#dc6555";
            case 5: return "#5cbee4";
            case 6: return "#59cb86";
            case 7: return "#98dc55";
            case 8: return "#4dd5b0";
            default : return "black";
        }
    },
    createBlock: function(){    //生成一个新方块
        this.index = Math.floor(Math.random() * this.maps.length);
        this.status = Math.floor(Math.random() * this.maps[this.index].length);
        return {
            shape: this.getCurrentBlock(),
            color: this.getDragCellColor(this.index),
            style: {}
        };
    },
    getCurrentBlock: function(){
        return this.maps[this.index][this.status];
    }
};


// WEBPACK FOOTER //
// ./src/js/Factory.js